import React, { useRef, useState } from 'react';
import SectionHead from './SectionHead';
import ContactModal from './ContactModal';
import { useLang } from '../LangContext';

const BASE = process.env.PUBLIC_URL + '/profile';

function MagneticBtn({ children, onClick }) {
  const ref = useRef(null);

  const handleMove = (e) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const dx = (e.clientX - (rect.left + rect.width / 2)) * 0.28;
    const dy = (e.clientY - (rect.top + rect.height / 2)) * 0.28;
    ref.current.style.transition = 'transform 100ms linear';
    ref.current.style.transform = `translate(${dx}px, ${dy}px)`;
  };

  const handleLeave = () => {
    if (!ref.current) return;
    ref.current.style.transition = 'transform 500ms cubic-bezier(0.2, 0.7, 0.1, 1)';
    ref.current.style.transform = '';
  };

  return (
    <button
      ref={ref}
      className="contact__cta"
      onClick={onClick}
      onMouseMove={handleMove}
      onMouseLeave={handleLeave}
    >
      {children}
    </button>
  );
}

export default function Contact() {
  const { t } = useLang();
  const [modalOpen, setModalOpen] = useState(false);

  // The hero terminal ("contact", "sudo hire-me") opens the modal from afar.
  React.useEffect(() => {
    const onAction = (e) => {
      if (e.detail?.type === 'contact') setModalOpen(true);
    };
    window.addEventListener('portfolio:action', onAction);
    return () => window.removeEventListener('portfolio:action', onAction);
  }, []);

  return (
    <section className="s contact fullpage-section" id="contact">
      {/* Closing frame: looking out at the water — the rain canvas draws on this glass. */}
      <div className="contact__bg" aria-hidden="true">
        <picture>
          <source type="image/webp" srcSet={`${BASE}/window-1200.webp 1200w, ${BASE}/window-1800.webp 1800w`} sizes="100vw" />
          <img src={`${BASE}/window-1200.jpg`} srcSet={`${BASE}/window-1200.jpg 1200w, ${BASE}/window-1800.jpg 1800w`} sizes="100vw" alt="" loading="lazy" decoding="async" width="1200" height="1500" />
        </picture>
      </div>
      <div className="s__inner">
        <SectionHead label={t.contact.label} />
        <div className="contact__giant">
          {t.contact.giantLine1} <span className="accent">{t.contact.giantAccent}</span><br />
          {t.contact.giantLine2}<br />
          {t.contact.giantLine3}
        </div>
        <div className="contact__row">
          <div className="contact__channels">
            <a href="mailto:lahminet0@gmail.com">email →</a>
            <a href="https://www.linkedin.com/in/traore-lamine-84bb7423a/?locale=en_US" target="_blank" rel="noopener noreferrer">linkedin →</a>
            <a href="https://github.com/NovzChrono" target="_blank" rel="noopener noreferrer">github →</a>
          </div>
          <MagneticBtn onClick={() => setModalOpen(true)}>
            {t.contact.cta} <span>→</span>
          </MagneticBtn>
        </div>
        <footer className="foot foot--inline">
          <span>{t.contact.footer}</span>
          <span>v2.0 · Portfolio · last build {new Date().toISOString().slice(0, 10)}</span>
        </footer>
      </div>

      <ContactModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </section>
  );
}
